import React from "react";
import { MdOutlineFavoriteBorder } from "react-icons/md";

export function SearchIcon({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="21"
      fill="none"
      viewBox="0 0 24 21"
    >
      <path
        stroke={color ?? "#fff"}
        strokeWidth="2"
        d="M11 15.833c3.866 0 7-2.611 7-5.833s-3.134-5.833-7-5.833S4 6.778 4 10s3.134 5.833 7 5.833z"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="2"
        d="M20 17.5L17 15"
      ></path>
    </svg>
  );
}

export function SearchAltIcon({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.99996 9.16668C4.99996 12.3883 7.61163 15 10.8333 15C14.055 15 16.6666 12.3883 16.6666 9.16668C16.6666 5.94502 14.055 3.33334 10.8333 3.33334C7.61163 3.33334 4.99996 5.94502 4.99996 9.16668Z"
        stroke={color ?? "#767676"}
        strokeWidth="2"
      />
      <path
        d="M13.3334 9.16666C13.3334 8.83832 13.2687 8.51324 13.1431 8.20995C13.0174 7.90663 12.8333 7.63104 12.6011 7.39889C12.369 7.16674 12.0934 6.9826 11.7901 6.85696C11.4868 6.73132 11.1617 6.66666 10.8334 6.66666"
        stroke={color ?? "#767676"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M3.33337 16.6667L5.83337 14.1667"
        stroke={color ?? "#767676"}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function TikeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19.5479 7.26647L20.1812 6.49252L19.4072 5.85928L17.8593 4.5928L17.0854 3.95956L16.4521 4.73352L8.66618 14.2496L6.2 12.4L5.4 11.8L4.8 12.6L3.6 14.2L3 15L3.8 15.6L8.56691 19.1752L9.33382 19.7504L9.94087 19.0084L19.5479 7.26647Z"
        stroke="#333333"
        strokeWidth="2"
      />
    </svg>
  );
}

export function FilledStarIcon({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6.87153 4.8133C7.2996 3.74618 7.5136 3.21262 7.86133 3.13867C7.95273 3.11922 8.04727 3.11922 8.13867 3.13867C8.4864 3.21262 8.7004 3.74618 9.12847 4.8133C9.37193 5.42016 9.4936 5.72359 9.72133 5.92996C9.78527 5.98785 9.8546 6.0394 9.9284 6.0839C10.1917 6.24256 10.5202 6.27198 11.1774 6.33084C12.2899 6.43048 12.8462 6.48029 13.0161 6.79742C13.0512 6.86316 13.0751 6.93429 13.0868 7.00789C13.1431 7.36322 12.7342 7.73522 11.9163 8.47936L11.6892 8.68596C11.3069 9.03382 11.1157 9.20776 11.0051 9.42482C10.9387 9.55502 10.8943 9.69529 10.8735 9.83989C10.8387 10.081 10.8947 10.3334 11.0067 10.838L11.0467 11.0184C11.2475 11.9234 11.3479 12.3759 11.2225 12.5983C11.1099 12.7981 10.9026 12.926 10.6735 12.937C10.4185 12.9491 10.0592 12.6563 9.34053 12.0707C8.86707 11.6849 8.63033 11.492 8.36753 11.4166C8.12733 11.3478 7.87267 11.3478 7.63253 11.4166C7.36967 11.492 7.13293 11.6849 6.65949 12.0707C5.94083 12.6563 5.58151 12.9491 5.3265 12.937C5.09743 12.926 4.89007 12.7981 4.77749 12.5983C4.65216 12.3759 4.75256 11.9234 4.95336 11.0184L4.99336 10.838C5.10533 10.3334 5.16131 10.081 5.12657 9.83989C5.10573 9.69529 5.06125 9.55502 4.99492 9.42482C4.88434 9.20776 4.69316 9.03382 4.31079 8.68596L4.08368 8.47936C3.26582 7.73522 2.85689 7.36322 2.91321 7.00789C2.92487 6.93429 2.94879 6.86316 2.98397 6.79742C3.15383 6.48029 3.71009 6.43048 4.8226 6.33084C5.47979 6.27198 5.80838 6.24256 6.07161 6.0839C6.14544 6.0394 6.21478 5.98785 6.27866 5.92996C6.5064 5.72359 6.62811 5.42016 6.87153 4.8133Z"
        fill={color ?? "#F8D105"}
        stroke={color ?? "#F8D105"}
        strokeWidth="2"
      />
    </svg>
  );
}

export function FavoriteIcon({ color, border, size }) {
  return (
    <MdOutlineFavoriteBorder color={color ? color : "white"} size={size ? size : 22} />
  );
}

export function DoneFillIcon({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19.5479 7.26647L20.1812 6.49252L19.4072 5.85928L17.8593 4.5928L17.0854 3.95956L16.4521 4.73352L8.66618 14.2496L6.2 12.4L5.4 11.8L4.8 12.6L3.6 14.2L3 15L3.8 15.6L8.56691 19.1752L9.33382 19.7504L9.94087 19.0084L19.5479 7.26647Z"
        stroke={color ?? "#333333"}
        strokeWidth="2"
      />
    </svg>
  );
}
/* export default {
  SearchIcon,

}; */
